    <div class="rental-return">
      <div class="page-header">
        <button mat-icon-button [routerLink]="['/rentals', rentalId]" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Приём автомобиля</h1>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="return-form">
        <mat-card class="form-card">
          <mat-card-content>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Пробег при возврате, км</mat-label>
              <input matInput formControlName="mileageAfter" type="number" required>
              <mat-error *ngIf="form.get('mileageAfter')?.hasError('required')">Укажите пробег</mat-error>
              <mat-error *ngIf="form.get('mileageAfter')?.hasError('serverError')">{{form.get('mileageAfter')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Уровень топлива, км</mat-label>
              <input matInput formControlName="fuelLevelAfter" type="number" min="1">
              <mat-error *ngIf="form.get('fuelLevelAfter')?.hasError('min')">Значение должно быть больше 0</mat-error>
              <mat-error *ngIf="form.get('fuelLevelAfter')?.hasError('serverError')">{{form.get('fuelLevelAfter')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Место возврата</mat-label>
              <input matInput formControlName="returnLocation" required>
              <mat-error *ngIf="form.get('returnLocation')?.hasError('required')">Укажите место возврата</mat-error>
              <mat-error *ngIf="form.get('returnLocation')?.hasError('serverError')">{{form.get('returnLocation')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <app-datetime-input
              formControlName="returnDate"
              dateLabel="Дата возврата"
              timeLabel="Время"
              [required]="true">
            </app-datetime-input>

            <app-image-upload
              formControlName="imagesAfter"
              label="Фото автомобиля после проката">
            </app-image-upload>

            <mat-divider class="section-divider"></mat-divider>

            <h3 class="section-title">Дополнительные услуги</h3>
            <p *ngIf="extraServices.length === 0" class="empty-hint">Список услуг пуст. Можно принять без доп. услуг.</p>
            <div formArrayName="extraServices" *ngIf="extraServices.length > 0">
              <div *ngFor="let esGroup of extraServicesForm.controls; let i = index" [formGroupName]="i" class="extra-service-row">
                <mat-checkbox formControlName="selected" class="extra-service-checkbox">
                  {{ extraServices[i].name }}
                </mat-checkbox>
                <mat-form-field appearance="outline" class="extra-service-amount">
                  <mat-label>Сумма, ₽</mat-label>
                  <input matInput type="number" formControlName="amount" min="0.01" step="0.01" inputmode="decimal" placeholder="0.00">
                  <mat-icon matSuffix>payments</mat-icon>
                  <mat-error *ngIf="esGroup.get('amount')?.hasError('min')">Сумма должна быть больше 0</mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <button mat-raised-button color="accent" type="submit" class="full-width-btn"
                [disabled]="form.invalid || submitting">
          <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
          <span *ngIf="!submitting"><mat-icon>assignment_return</mat-icon> Подтвердить приём</span>
        </button>
      </form>
    </div>
